// extracted by mini-css-extract-plugin
export default {"container":"No-z","heading":"Oo-z","text":"Po-z","info":"Qo-z","link":"Ro-z","fullMaxWidth":"So-z"};